import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";

const SECTIONS = [
  {
    title: "Who we are",
    paras: [
      "Fox Project Management Consultancy Ltd (\u201cFox\u201d, \u201cwe\u201d, \u201cus\u201d) is the data controller for personal information collected through this website.",
      "Registered office: Westgate House, Seedhill, Paisley, PA1 1JE. Registered in Scotland, company number SC900643. You can contact us at any time at info@foxconsultancy.org.",
    ],
  },
  {
    title: "What we collect",
    paras: [
      "When you submit our enquiry form we collect the details you provide: your name, email address, phone number (optional), company, the service you are interested in, an estimated project value and your message.",
      "We also keep any correspondence you send us directly by email or phone.",
    ],
  },
  {
    title: "How we use it",
    paras: [
      "We use your information to respond to your enquiry, prepare proposals, deliver our services and keep appropriate business records.",
      "We will not send you marketing emails without your consent, and we never sell or rent your personal information to anyone.",
    ],
  },
  {
    title: "Our legal basis",
    paras: [
      "We process your information on the basis of our legitimate interests in responding to business enquiries and, where relevant, because processing is necessary to take steps towards a contract with you.",
    ],
  },
  {
    title: "How your enquiry is handled",
    paras: [
      "Enquiry details are emailed to our business inbox and stored in a secure database. We use trusted service providers for email delivery and website hosting, who process information on our behalf under appropriate safeguards.",
    ],
  },
  {
    title: "How long we keep it",
    paras: [
      "We keep your information only for as long as needed to handle your enquiry and any resulting engagement, and to meet any legal or accounting requirements.",
    ],
  },
  {
    title: "Your rights",
    paras: [
      "Under UK data protection law you have the right to access, correct or erase your personal information, to restrict or object to our processing of it, and to data portability. To exercise any of these rights, email info@foxconsultancy.org.",
      "You also have the right to complain to the Information Commissioner's Office (ico.org.uk) if you are unhappy with how we handle your information.",
    ],
  },
  {
    title: "Cookies and analytics",
    paras: [
      "This website does not use tracking cookies or third-party analytics. Only essential technical storage required for the site to function is used.",
    ],
  },
  {
    title: "Changes to this policy",
    paras: [
      "We may update this policy from time to time. Any changes will be posted on this page. This policy was last updated in September 2026.",
    ],
  },
];

export default function Privacy() {
  return (
    <>
      <PageHeader
        overline="Privacy"
        lines={["Privacy policy"]}
        intro="How Fox Project Management Consultancy Ltd collects, uses and protects your personal information."
        testid="privacy-headline"
      />
      <section className="max-w-4xl mx-auto px-6 py-20 sm:py-28" data-testid="privacy-content">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.04}>
            <div className="grid sm:grid-cols-12 gap-4 py-8 border-t border-zinc-800/60 last:border-b">
              <span className="sm:col-span-2 font-mono text-xs text-zinc-600 tracking-[0.2em] pt-1">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="sm:col-span-10">
                <h2 className="font-display text-lg font-bold text-zinc-100">{s.title}</h2>
                {s.paras.map((p) => (
                  <p key={p.slice(0, 32)} className="mt-3 text-sm text-zinc-400 font-light leading-relaxed">
                    {p}
                  </p>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </section>
    </>
  );
}
